import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { NavLink } from "react-router-dom";

import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";

const WalletsItem = ({ value, notification, setNotification, t }) => {
  const { id, clientId, currency, paymentSystem, balance, connection, wallet, tag } = value;

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTableRow
      scroll="auto"
      col="8"
      className="wallet-table__row"
      onClick={(e) => showDetails(e)}
      cursor="pointer"
      as={NavLink}
      to={`/wallet/${id}`}
    >
      <StyledCol inline data-title={t("wallets.table.clientId")}>
        {clientId ?
          <CopyToClipboard
            className="stop-event"
            text={clientId}
            onCopy={() => {
              setNotification({
                ...notification,
                visible: true,
                type: "success",
                message: t("wallets.table.copied")
              });
            }}
          >
            <StyledBreakWord as="p">
              {clientId} <StyledCopy
              title={t("wallets.table.copy")}
              className="icon-light-copy"
            />
            </StyledBreakWord>
          </CopyToClipboard> : "--"}
      </StyledCol>
      <StyledCol data-title={t("wallets.table.currency")}>
        {currency}
      </StyledCol>
      <StyledCol data-title={t("wallets.table.paymentSystem")}>
        {paymentSystem}
      </StyledCol>
      <StyledCol data-title={t("wallets.table.balance")}>
        {balance}
      </StyledCol>
      <StyledCol inline data-title={t("wallets.table.project")}>
        <StyledBreakWord as="p">
          {connection.project.name}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol inline data-title={t("wallets.table.service")}>
        <StyledBreakWord as="p">
          {connection.service.name}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol inline data-title={t("wallets.table.wallet")}>
        <CopyToClipboard
          className="stop-event"
          text={wallet}
          onCopy={() => {
            setNotification({
              ...notification,
              visible: true,
              type: "success",
              message: t("wallets.table.copied")
            });
          }}
        >
          <StyledBreakWord as="p">
            {wallet} <StyledCopy
            title={t("wallets.table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol data-title={t("wallets.table.tag")}>
        {tag ? (
          <CopyToClipboard
            className="stop-event"
            text={tag}
            onCopy={() => {
              setNotification({
                ...notification,
                visible: true,
                type: "success",
                message: t("wallets.table.copied")
              });
            }}
          >
            <StyledBreakWord as="p">
              {tag} <StyledCopy
              title={t("wallets.table.copy")}
              className="icon-light-copy"
            />
            </StyledBreakWord>
          </CopyToClipboard>
        ) : "--"}
      </StyledCol>
    </StyledTableRow>
  );
};

export default WalletsItem;